import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { Card } from "react-bootstrap";
import { Container } from "./ReservationsDashboard";
import { SVGIcon } from "../../../components/Base";
import { RESERVATIONS_TAB_LIST } from "./ReservationsConsole";
import moment from "moment";
import { get, groupBy } from "lodash";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  DB_DATE_FORMAT,
  DB_HOURS_FORMAT,
  RESERVATION_COLOR,
} from "../../../constants";
import PacmanWrapper from "../../../components/dashboard/PacmanWrapper";
import APIComponent from "../../../components/API";
import ReservationsOverview from "./ReservationsOverview";
import { GetDataFromEvent, tryParse } from "../../../helpers";
import ReservationsGuests from "./ReservationsGuests";
import { getReservationHighlightColor } from "../../../helpers/reservations";
import ReservationLegend from "../../../partials/reservations/ReservationLegend";

const NAV_FOOTER_LIST = {
  WALK_IN: "queue",
  UPCOMING: "upcoming",
  SEATED: "seated",
  FINISHED: "finished",
  CANCELLED: "cancelled",
};
const NAV_FOOTER_ARR = [
  { icon: NAV_FOOTER_LIST.WALK_IN, label: "Walk-in/Queue" },
  { icon: NAV_FOOTER_LIST.UPCOMING, label: "Upcoming" },
  { icon: NAV_FOOTER_LIST.SEATED, label: "Seated" },
  { icon: NAV_FOOTER_LIST.FINISHED, label: "Finished" },
  { icon: NAV_FOOTER_LIST.CANCELLED, label: "Cancelled" },
];

export const STATUS_ARR = {
  EXPECTED: "expected",
  SEATED: "seated",
  FINISHED: "finished",
  PAID: "paid",
  CLOSED: "closed",
};

const ALLERGIES_ICON = [
  { icon: "peanuts", text: "Peanuts" },
  { icon: "vegan", text: "Vegan" },
  { icon: "vegetarian", text: "Vegetarian" },
  { icon: "seafood", text: "Seafood" },
];

class ReservationList extends APIComponent {
  constructor(props) {
    super(props);
    const store_id = this.props.store_id;
    this.state = {
      tab_selected: NAV_FOOTER_LIST.UPCOMING,
      list_selected: RESERVATIONS_TAB_LIST.RESERVATIONS_QUEUE,
      max_guest_enabled: 8,
      reservations: [],
      data_status: "fetching",
      all_reservations: {},
      store_id,
      onGoingService: null,
      store: null,
      selected_reservation: null,
    };
  }

  async getData() {
    try {
      this._isMounted &&
        this.setState({
          data_status: "fetching",
        });

      let { store_id = "", selected_date = moment().format(DB_DATE_FORMAT) } =
        this.props;

      if (this.props.api) {
        const [reservationsResponse, serviceResponse, storeResponse] =
          await Promise.all([
            this.props.api.get(
              `/reservation/store/${store_id}?date=${selected_date}`,
            ),
            this.props.api.get(
              `/branded-website/reservation/${store_id}/service/current`,
            ),
            this.props.api.get(`/store/${store_id}`),
          ]);

        if (reservationsResponse.data) {
          const allReservationsData = reservationsResponse.data;

          // Combine 'cancelled' and 'cancelled_no_show' reservations for the 'CANCELLED' tab
          const cancelledKey = NAV_FOOTER_LIST.CANCELLED;
          const cancelledNoShowKey = "cancelled_no_show"; // Assuming this might be a separate key from backend

          if (
            allReservationsData[cancelledKey] ||
            allReservationsData[cancelledNoShowKey]
          ) {
            allReservationsData[cancelledKey] = [
              ...(allReservationsData[cancelledKey] || []),
              ...(allReservationsData[cancelledNoShowKey] || []),
            ];
            delete allReservationsData[cancelledNoShowKey]; // Remove if no longer needed separately
          }

          this.setState({
            all_reservations: allReservationsData,
            reservations: allReservationsData[this.state.tab_selected] || [],
            data_status: "fetched",
          });
        }

        if (serviceResponse.data) {
          this.setState({ onGoingService: serviceResponse.data });
        }

        if (storeResponse.data) {
          this.setState({ store: storeResponse.data });
        }
      }

      this.handleOnDataFetched();
    } catch (error) {
      this._isMounted && this.setState({ error: error, showSwalError: true });
      this.handleOnDataFetchError();
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.getData();
  }

  async componentDidUpdate(prevProps) {
    const { selected_date, refresh } = this.props;
    if (
      selected_date !== prevProps.selected_date ||
      refresh !== prevProps.refresh
    ) {
      this.getData();
    }
  }

  handleOptimisticUpdate = (reservationId, newTableNumber) => {
    this.setState((prevState) => {
      const newAllReservations = { ...prevState.all_reservations };

      for (const key in newAllReservations) {
        if (Array.isArray(newAllReservations[key])) {
          newAllReservations[key] = newAllReservations[key].map(
            (reservation) => {
              if (reservation._id === reservationId) {
                return {
                  ...reservation,
                  reservation_notes: {
                    ...reservation.reservation_notes,
                    preferred_table_number: newTableNumber,
                  },
                };
              }
              return reservation;
            },
          );
        }
      }
      return { all_reservations: newAllReservations };
    });
  };
  onClickConsoleTab = (e) => {
    const name = GetDataFromEvent(e, "data-item");
    this.setState({ list_selected: name });
    this.props.onListTabChange?.(name);
  };

  onClickNavFooter = (e) => {
    const name = GetDataFromEvent(e, "data-item");
    this.setState((prevState) => ({
      tab_selected: name,
      reservations: prevState.all_reservations[name] || [],
    }));
    this.props.onTabChange?.();
  };

  render() {
    const {
      list_selected,
      tab_selected,
      reservations,
      onGoingService,
      all_reservations,
      store,
    } = this.state;

    const getListClass = (name = "", list_selected = "") => {
      const isActive = name === list_selected;
      const baseClasses =
        "d-flex font-weight-bolder font-pickup-sm-2 p-3 text-capitalize";
      if (isActive) {
        return `${baseClasses} active-tab`;
      }
      return `${baseClasses} cursor-pointer`;
    };

    const listHeaderIndex = NAV_FOOTER_ARR.findIndex(
      (footer) => footer.icon === tab_selected,
    );

    const guest_count = reservations.reduce((totalQty, reservation) => {
      const reservationQty = (reservation.order_details || [])
        .filter((detail) => detail.item.type === "reservation_experience")
        .reduce((subTotal, experience) => subTotal + experience.qty, 0);
      return totalQty + reservationQty;
    }, 0);

    const isLoading = this.state.data_status === "fetching";

    const isOverview = list_selected === RESERVATIONS_TAB_LIST.OVERVIEW;
    const isGuests = list_selected === RESERVATIONS_TAB_LIST.GUESTS;

    return (
      <Container
        className="d-flex flex-row"
        style={{ width: isOverview || isGuests ? "100%" : "auto" }}
      >
        <style>{`
          .active-tab {
            border-bottom: 3px solid ${RESERVATION_COLOR};
          }
        `}</style>
        <Card className="w-100">
          <Card.Header className="d-flex p-0">
            <div className="d-flex flex-column">
              <div
                className={getListClass(
                  RESERVATIONS_TAB_LIST.RESERVATIONS_QUEUE,
                  list_selected,
                )}
                data-item={RESERVATIONS_TAB_LIST.RESERVATIONS_QUEUE}
                onClick={this.onClickConsoleTab}
              >
                Reservations
              </div>
            </div>
            <div className="d-flex flex-column">
              <div
                className={getListClass(
                  RESERVATIONS_TAB_LIST.TASKS,
                  list_selected,
                )}
                data-item={RESERVATIONS_TAB_LIST.TASKS}
                onClick={this.onClickConsoleTab}
              >
                Tasks
              </div>
            </div>
            <div className="d-flex flex-column">
              <div
                className={getListClass(
                  RESERVATIONS_TAB_LIST.GUESTS,
                  list_selected,
                )}
                data-item={RESERVATIONS_TAB_LIST.GUESTS}
                onClick={this.onClickConsoleTab}
              >
                Guests
              </div>
            </div>
            <div className="d-flex flex-column">
              <div
                className={getListClass(
                  RESERVATIONS_TAB_LIST.PENDING,
                  list_selected,
                )}
                data-item={RESERVATIONS_TAB_LIST.PENDING}
                onClick={this.onClickConsoleTab}
              >
                Pending
              </div>
            </div>
          </Card.Header>

          <div className="d-flex">
            <div
              data-item={RESERVATIONS_TAB_LIST.OVERVIEW}
              className={`${getListClass(
                RESERVATIONS_TAB_LIST.OVERVIEW,
                list_selected,
              )} justify-content-center align-items-center`}
              onClick={this.onClickConsoleTab}
            >
              <i className="fas fa-chart-bar text-info mr-2"></i>
              Overview
            </div>
          </div>
          <Card.Body className="d-flex p-0 flex-column">
            {isLoading && (
              <>
                <div className="d-flex justify-content-center align-items-center h-100">
                  <PacmanWrapper />
                </div>
              </>
            )}
            {!isLoading && list_selected === RESERVATIONS_TAB_LIST.OVERVIEW && (
              <ReservationsOverview
                store={store}
                reservations={all_reservations[NAV_FOOTER_LIST.UPCOMING] || []}
                onGoingService={onGoingService}
                storeName={this.props.storeName}
                selectedDate={this.props.selected_date}
                onDateInputChange={this.props.onDateInputChange}
                onGuestReservationClick={this.props.onGuestReservationClick}
                onOptimisticUpdate={this.handleOptimisticUpdate}
              />
            )}
            {!isLoading && list_selected === RESERVATIONS_TAB_LIST.GUESTS && (
              <ReservationsGuests
                store_id={this.props.store_id}
                api={this.props.api}
                onGuestReservationClick={this.props.onGuestReservationClick}
              />
            )}
            {!isLoading && list_selected === RESERVATIONS_TAB_LIST.PENDING && (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p>Pending reservations will be shown here.</p>
              </div>
            )}
            {!isLoading &&
              list_selected !== RESERVATIONS_TAB_LIST.OVERVIEW &&
              list_selected !== RESERVATIONS_TAB_LIST.GUESTS && (
                <>
                  <div className="d-flex flex-row">
                    <MaxEnabledDiv>
                      <span>
                        On Going Service:{" "}
                        <b> {onGoingService?.name || "None"}</b>
                      </span>
                    </MaxEnabledDiv>
                  </div>
                  <div
                    className="d-flex flex-row font-weight-bolder text-capitalize p-2 justify-content-space-between"
                    style={{ borderBottom: "1px solid #707070" }}
                  >
                    <div className="d-flex flex-row">
                      <SVGIcon
                        icon={`Reservations/${tab_selected}`}
                        title={tab_selected}
                        className="mr-2"
                      />
                      {NAV_FOOTER_ARR[listHeaderIndex].label}
                    </div>
                    <div className="d-flex flex-row">{guest_count}</div>
                  </div>
                  <div
                    style={{
                      overflowY: "auto",
                      height: "calc(100% - 26px)", // 26px is the height of the legend
                    }}
                  >
                    <ReservationOverviewCard
                      isLoading={isLoading}
                      store={store}
                      onGoingService={onGoingService}
                      tab_selected={tab_selected}
                      reservations={reservations}
                      onReservationOverviewClick={this.props.onReservationClick}
                    />
                  </div>
                  <ReservationLegend
                    className="p-2 justify-content-space-evenly border-top"
                    fontSize="0.77rem"
                  />
                </>
              )}
          </Card.Body>
          <Card.Footer className="d-flex flex-row p-0">
            {list_selected !== RESERVATIONS_TAB_LIST.OVERVIEW &&
              list_selected !== RESERVATIONS_TAB_LIST.GUESTS && (
                <NavFooter
                  onClickNavFooter={this.onClickNavFooter}
                  all_reservations={all_reservations}
                  tab_selected={tab_selected}
                />
              )}
          </Card.Footer>
        </Card>
      </Container>
    );
  }
}
const getSeatedBackgroundColor = (totalMinutes, diningLength) => {
  const WARNING_THRESHOLD_MINUTES = 15;
  const SEATED_COLOR = "#0AFF00"; // Green
  const WARNING_COLOR = "#FF7F00"; // Orange
  const OVERDUE_COLOR = "#F64E60"; // Red

  if (totalMinutes > diningLength) {
    return OVERDUE_COLOR;
  }
  if (totalMinutes >= diningLength - WARNING_THRESHOLD_MINUTES) {
    return WARNING_COLOR;
  }
  return SEATED_COLOR;
};

const ElapsedTime = ({ changeTimestamp, status, onGoingService }) => {
  const [elapsed, setElapsed] = useState("00:00");
  const [backgroundColor, setBackgroundColor] = useState("#0AFF00");

  useEffect(() => {
    let interval;
    const timestamps = changeTimestamp ? JSON.parse(changeTimestamp) : {};
    const seatedColor = "#0AFF00";

    const formatDuration = (duration) => {
      const hours = duration.hours();
      const minutes = String(duration.minutes()).padStart(2, "0");
      const seconds = String(duration.seconds()).padStart(2, "0");
      if (hours > 0) {
        return `${String(hours).padStart(2, "0")}:${minutes}:${seconds}`;
      }
      return `${minutes}:${seconds}`;
    };
    const diningLength = onGoingService?.interval || 60; // Default to 60 mins if not set

    if (status === NAV_FOOTER_LIST.SEATED && timestamps.accepted) {
      const acceptedTime = moment(timestamps.accepted);
      const updateElapsed = () => {
        const now = moment();
        const duration = moment.duration(now.diff(acceptedTime));
        const totalMinutes = duration.asMinutes();
        const color = getSeatedBackgroundColor(totalMinutes, diningLength);
        setBackgroundColor(color);
        setElapsed(formatDuration(duration));
      };

      updateElapsed(); // Initial update
      interval = setInterval(updateElapsed, 1000);
    } else if (
      status === NAV_FOOTER_LIST.FINISHED &&
      timestamps.accepted &&
      timestamps.completed
    ) {
      const acceptedTime = moment(timestamps.accepted);
      const completedTime = moment(timestamps.completed);
      const duration = moment.duration(completedTime.diff(acceptedTime));
      setElapsed(formatDuration(duration));
      const totalMinutes = duration.asMinutes();
      const color = getSeatedBackgroundColor(totalMinutes, diningLength);
      setBackgroundColor(color);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [changeTimestamp, status, onGoingService]);

  return (
    <div
      className="d-flex justify-content-center my-1 w-100"
      style={{
        color: "#000",
        backgroundColor: backgroundColor,
        fontSize: "0.9rem",
        lineHeight: "1rem",
      }}
    >
      {elapsed}
    </div>
  );
};
const ReservationOverviewCard = (props) => {
  const {
    reservations = [],
    tab_selected = "",
    onReservationOverviewClick,
    onGoingService,
  } = props;

  const sortedReservations = [...reservations].sort((a, b) =>
    moment(a.order_time, DB_HOURS_FORMAT).diff(
      moment(b.order_time, DB_HOURS_FORMAT),
    ),
  );

  const groupedByTime = groupBy(sortedReservations, "order_time");

  const renderHighlight = (color, isExclusive) => {
    if (isExclusive) {
      return (
        <div className="w-5px">
          <div className="w-100 h-50" style={{ backgroundColor: color }} />
          <div
            className="w-100 h-50"
            style={{ backgroundColor: RESERVATION_COLOR }}
          />
        </div>
      );
    }
    return <div className="w-5px" style={{ backgroundColor: color }} />;
  };

  return Object.entries(groupedByTime).map(([time, reservationsInGroup]) => {
    return (
      <div key={time} className="p-2">
        <div className="d-flex flex-row font-weight-bolder">
          {moment(time, DB_HOURS_FORMAT).format("hh:mm A")}
        </div>
        {reservationsInGroup.map((reservation, idx) => {
          const {
            guest_customer,
            order_details,
            change_timestamp,
            status,
            notes,
          } = reservation;
          const { partner_identifier } = reservation;
          const isVip = partner_identifier?.level === "VIP";
          let parsedNotes = {};
          try {
            parsedNotes = notes ? JSON.parse(notes) : {};
          } catch (e) {
            // notes is not a valid JSON
          }
          const dietary = get(parsedNotes, "dietary", []);
          const celebration = get(parsedNotes, "celebration", []);
          const isPending =
            reservation.payment?.status === "pending" ||
            reservation.payment?.status === "failed";
          const isPdr = reservation.reservation_notes?.table?.isExclusive;
          const isPaid = reservation.payment?.amount > 0;

          const color = getReservationHighlightColor({
            isVip,
            isPaid,
            hasDietary: dietary.length > 0,
            isPendingPayment: isPending,
          });

          const customer_name = `${guest_customer.last_name}, ${guest_customer.first_name}`;
          const experience = order_details.find(
            (detail) => detail.item.type === "reservation_experience",
          );
          const table = order_details.find(
            (detail) => detail.item.type === "reservation",
          );

          const experiences = order_details.filter(
            (detail) => detail.item.type === "reservation_experience",
          );

          const guest_count = experiences.reduce(
            (acc, cur) => acc + cur.qty,
            0,
          );
          return (
            <Card className="m-2" key={`reservation-card-${idx}`}>
              <div
                className="d-flex flex-row reservation-overview-card"
                style={{
                  borderColor: "#D1D3E0",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  overflow: "hidden",
                }}
                onClick={() => onReservationOverviewClick(reservation)}
              >
                {renderHighlight(color, isPdr)}
                <div
                  className="d-flex flex-row overview-col justify-content-space-between"
                  style={{
                    flexBasis: "100%",
                    borderRight: `3px solid`,
                  }}
                >
                  <div className="d-flex flex-column p-1 ml-2">
                    <div className="d-flex flex-row font-card-title font-weight-bolder align-items-center text-capitalize">
                      <div
                        style={{
                          maxWidth: 300,
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {customer_name}
                      </div>
                    </div>
                    <div className="d-flex flex-column">
                      {experience && (
                        <div className="d-flex align-items-center">
                          <SVGIcon
                            icon="Reservations/reservation-icon"
                            fill="#464E5F"
                            variant="dark"
                          />
                          <span className="ml-1" style={{ fontSize: "1.2rem" }}>
                            {experience.item.name}
                          </span>
                        </div>
                      )}
                      {table && (
                        <div className="d-flex align-items-center">
                          <SVGIcon
                            icon="Reservations/table-black"
                            fill="#464E5F"
                            variant="dark"
                            className="bg-black"
                          />
                          <span className="ml-1" style={{ fontSize: "1.2rem" }}>
                            {table.item.name}
                          </span>
                          {isPdr && (
                            <span
                              className="badge badge-pill ml-2 text-white font-weight-boldest shadow-sm"
                              style={{
                                backgroundColor: RESERVATION_COLOR,
                                fontSize: "0.65rem",
                                padding: "0.2rem 0.5rem",
                                letterSpacing: "0.5px",
                                verticalAlign: "middle",
                              }}
                            >
                              PDR
                            </span>
                          )}
                        </div>
                      )}
                      <div className="d-flex"></div>
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-center">
                    {isVip && (
                      <div className="d-flex justify-content-center align-items-center font-pickup-lg m-2">
                        <i
                          className="fas fa-crown ml-2"
                          style={{ color: "#FFD700" }}
                        />
                      </div>
                    )}
                    {dietary.length > 0 && (
                      <div className="d-flex justify-content-center align-items-center font-pickup-lg m-2">
                        <i
                          className="fas fa-exclamation-triangle text-danger"
                          title={dietary.map((d) => d.label).join(", ")}
                        ></i>
                      </div>
                    )}
                    {celebration.length > 0 && (
                      <div className="d-flex justify-content-center align-items-center font-pickup-lg m-2">
                        <i
                          className="fas fa-gift text-info"
                          title={celebration.map((c) => c.label).join(", ")}
                        ></i>
                      </div>
                    )}
                    <div className="d-flex flex-row justify-content-center align-items-center"></div>
                    <div className="d-flex justify-content-center align-items-center font-pickup-lg font-weight-bolder m-2">
                      {guest_count}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex flex-column px-4 justify-content-center align-items-center font-weight-bolder"
                  style={{
                    background: "#EEF0F6",
                    lineHeight: "1.6rem",
                  }}
                >
                  <SVGIcon
                    icon="Reservations/seated"
                    fill="#464E5F"
                    variant="dark"
                  />
                  {[NAV_FOOTER_LIST.SEATED, NAV_FOOTER_LIST.FINISHED].indexOf(
                    tab_selected,
                  ) > -1 && (
                    <ElapsedTime
                      onGoingService={onGoingService}
                      changeTimestamp={change_timestamp}
                      status={tab_selected}
                    />
                  )}
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    );
  });
};

const NavFooter = (props) => {
  const { onClickNavFooter, all_reservations } = props;

  return NAV_FOOTER_ARR.map(({ icon, label }, index) => {
    const { tab_selected } = props;
    const isTabSelected = tab_selected === icon;
    const reservations = all_reservations[icon] || [];
    const count = reservations.reduce((totalQty, reservation) => {
      const reservationQty = (reservation.order_details || [])
        .filter((detail) => detail.item.type === "reservation_experience")
        .reduce((subTotal, experience) => subTotal + experience.qty, 0);
      return totalQty + reservationQty;
    }, 0);

    const isWalkIn = label === "Walk-in/Queue";
    const isDisabled = isWalkIn;
    return (
      <div
        className={`d-flex ${isTabSelected ? "active-tab" : ""}`}
        key={`reservations-${icon}`}
        style={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          backgroundColor: isTabSelected ? RESERVATION_COLOR : "#ffffff",
          opacity: isDisabled ? 0.5 : 1,
          position: "relative", // ← add this
        }}
        data-item={icon}
        onClick={isDisabled ? null : onClickNavFooter}
      >
        <div
          className={`d-flex flex-column justify-content-center flex-grow-1 flex-shrink-0 m-1`}
          style={{
            width: 80,
            height: 60,
            position: "relative" /* maybe here */,
          }}
        >
          <div
            className="d-flex flex-row h-100"
            style={{ position: "relative" }}
          >
            {count > 0 && (
              <div
                className={`badge badge-${
                  isTabSelected ? "white" : "info"
                }  position-absolute`}
                style={{
                  top: "5px",
                  right: "5px",
                }}
              >
                {count}
              </div>
            )}
            <div
              className="d-flex flex-grow-1 justify-content-center"
              style={{ alignItems: "flex-end" }}
            >
              <FooterIcon>
                <SVGIcon
                  icon={`Reservations/${icon}${isTabSelected ? `-active` : ""}`}
                  title={label}
                />
              </FooterIcon>
            </div>
          </div>
          <div
            className="d-flex text-capitalize justify-content-center flex-grow-1"
            style={{
              fontSize: "0.85rem",
              lineHeight: "1rem",
              textAlign: "center",
              color: isTabSelected ? "#FFF" : "#000",
            }}
          >
            {label}
          </div>
        </div>
      </div>
    );
  });
};

const YellowDollarSign = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffc400;
  border-radius: 15px;
  height: 15px;
  width: 15px;
  font-size: 0.9rem;
  text-align: center;
  margin-left: 0.5rem;
`;

export const OrangeTag = styled.div`
  width: 38px;
  height: 13px;
  background: #ea3323 0% 0% no-repeat padding-box;
  border-radius: 15px;
  color: #ffffff;
  letter-spacing: 0.36px;
  font-size: 0.7rem;
  text-align: center;
`;

const MaxEnabledDiv = styled.div`
  width: 100%;
  display: flex;
  background: #dedede 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 5px;
  justify-content: center;
`;
const FooterIcon = styled.span`
  .svg-icon svg {
    height: 28px;
    width: 28px;
  }
  margin-bottom: 5px;
`;
export default ReservationList;
